import { render, staticRenderFns } from "./QrtlyAccountStatement.vue?vue&type=template&id=2b76411d&scoped=true&"
import script from "./QrtlyAccountStatement.vue?vue&type=script&lang=js&"
export * from "./QrtlyAccountStatement.vue?vue&type=script&lang=js&"
import style0 from "./QrtlyAccountStatement.vue?vue&type=style&index=0&id=2b76411d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76411d",
  null
  
)

export default component.exports